import React from "react";
import { Reveal } from "../shared/Reveal";

const MANIFESTO_BG =
  "linear-gradient(180deg,rgba(11,21,51,.74),rgba(11,21,51,.85)),url('/brand/manifesto.png')";

export default function Manifesto() {
  return (
    <section className="manifesto" style={{ backgroundImage: MANIFESTO_BG }}>
      <div className="wrap">
        <Reveal className="eyebrow" tag="div">A NEW ERA FOR BUILDINGS</Reveal>
        <Reveal className="mtitle" tag="div">Every Building Will <span className="g">Think for Itself.</span></Reveal>
        <div className="msteps">
          {[
            ["30+ YEARS", "The Foundation", <>For over 30 years, we have installed renewable energy technologies — helping buildings generate cleaner power.</>],
            ["TODAY", "Out of the Dark", <>Through <b>IoT, Artificial Intelligence and real-time intelligence</b>, every building can understand how it performs, identify waste, monitor critical assets and make better operational decisions.</>],
            ["THE SHIFT", "Intelligence Layer", <>This isn't simply monitoring. It is the foundation of a smarter building — <b>the intelligence layer that has been missing.</b></>],
          ].map(([lab, big, body], i) => (
            <Reveal className="mstep" tag="div" key={lab} style={{ transitionDelay: `${i * 0.1}s` }} data-testid={`manifesto-step-${i}`}>
              <div className="lab">{lab}</div>
              <div className="big">{big}</div>
              <p>{body}</p>
            </Reveal>
          ))}
        </div>
        <div className="crescendo">
          <Reveal className="c1" tag="div">Knowledge Before Investment.</Reveal>
          <Reveal className="c2" tag="div">Making the Invisible Visible.</Reveal>
          <Reveal className="c3" tag="div">Every Building Will Think for Itself.</Reveal>
        </div>
      </div>
    </section>
  );
}
